// pages/FormViewerPage/sections/OrderSummarySection.tsx — Quantity, summary, CTA & submission error
import React from 'react';
import TrustBadges from '../../../components/TrustBadges';
import { QuantityRow } from './orderSummary/QuantityRow';
import { PriceRows } from './orderSummary/PriceRows';
import { SubmitButton } from './orderSummary/SubmitButton';
import { computeShippingLabel } from './orderSummary/shippingLabel';
import { ms } from '../../../locales/ms';

export const OrderSummarySection: React.FC<{ hook: any; subtotal: number; hideSubmit?: boolean }> = ({ hook, subtotal, hideSubmit }) => {
    const { form, shippingCost, submission, selectedEverproRate, currentCombination } = hook;

    // Mode Simpel / Konsultasi (lead only): blok harga disembunyikan.
    // Konsultasi: Jumlah ikut hilang — sisa tombol submit saja.
    const isSimpleLead = form.addressInputMode === 'simple' && !form.javaOnly;
    const isConsult = !!form?.thankYouPage?.consultationMode;
    const hideDetails = isSimpleLead || isConsult;
    const { shippingLabel, isSimpleBayar } = computeShippingLabel(form, shippingCost, selectedEverproRate, currentCombination ?? null, hook.quantity ?? 1);

    return (
        <div className="border-t dark:border-slate-700 pt-4 mt-4 space-y-2">
            {!hideDetails && <h3 className="font-bold text-lg text-slate-900 dark:text-slate-100">{ms(form, m => m.orderSummary, 'Ringkasan Pesanan')}</h3>}
            {!isConsult && <QuantityRow quantity={hook.quantity} setQuantity={hook.setQuantity} form={form} />}
            <PriceRows hook={hook} subtotal={subtotal} shippingLabel={shippingLabel} isSimpleBayar={isSimpleBayar} hideDetails={hideDetails} />
            {form.trustBadgeSettings?.active && form.trustBadgeSettings.position === 'above-cta' && <div className="mt-4"><TrustBadges settings={form.trustBadgeSettings} /></div>}
            {!hideSubmit && <SubmitButton hook={hook} isSimpleLead={isSimpleLead} />}
            {submission?.error && <div className={'mt-3 p-3 border rounded-lg text-sm ' + (submission.retrying ? 'bg-amber-50 dark:bg-amber-900/30 border-amber-200 dark:border-amber-800 text-amber-700 dark:text-amber-300' : 'bg-red-50 dark:bg-red-900/30 border-red-200 dark:border-red-800 text-red-700 dark:text-red-300')}>{submission.retrying ? '⏳' : '⚠️'} {submission.error}</div>}
            {form.trustBadgeSettings?.active && form.trustBadgeSettings.position === 'below-cta' && <div className="mt-6"><TrustBadges settings={form.trustBadgeSettings} /></div>}
        </div>
    );
};
